import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import TextLink from 'LuxKit/TextLink'
import FormatLoyaltyPoints from 'loyalty/components/Formatters/FormatLoyaltyPoints'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import { useAppSelector } from 'hooks/reduxHooks'

const BUY_POINTS_PATH = '/societe/buy-points'

const BannerWrap = styled.div`
  margin: 0 ${rem(-24)} ${rem(8)};
`

/**
 * Promotional banner shown inside the Maldives charter calendar when reward fare
 * classes are available. Encourages members to top up their loyalty points.
 */
function MaldivesCharterBuyPointsBanner() {
  const intl = useIntl()
  const loyaltyProgramName = getLoyaltyProgramDisplayName()
  const memberId = useAppSelector(state => state.auth.account.memberId)
  const userPoints = useAppSelector(state => state.loyalty.account.data?.points)
  const isLoggedIn = !!memberId

  const message = isLoggedIn && userPoints != null
    ? intl.formatMessage(
        {
          id: 'SvmisGeNAPN1IAzRctk-',
          defaultMessage: '<bold>You have {points}.</bold> Need more {loyaltyProgramName} points? Limited-time bonus on top-ups. <link>Buy points</link>',
          description: 'Promotional banner in the Maldives charter calendar showing the logged-in user their current points balance and encouraging them to top up loyalty points.',
        },
        {
          loyaltyProgramName,
          points: <FormatLoyaltyPoints points={userPoints} />,
          bold: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
          link: (chunks: React.ReactNode) => (
            <TextLink size="medium" weight="regular" to={BUY_POINTS_PATH}>{chunks}</TextLink>
          ),
        },
      )
    : intl.formatMessage(
        {
          id: 'Ik2Tu0RTW55HRZiH-32E',
          defaultMessage: '<bold>Need more {loyaltyProgramName} points?</bold> Limited-time bonus on top-ups. <link>Buy points</link>',
          description: 'Promotional banner in the Maldives charter calendar encouraging logged-out users to top up loyalty points with a limited-time bonus offer.',
        },
        {
          loyaltyProgramName,
          bold: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
          link: (chunks: React.ReactNode) => (
            <TextLink size="medium" weight="regular" to={BUY_POINTS_PATH}>{chunks}</TextLink>
          ),
        },
      )

  return (
    <BannerWrap>
      <MessageBanner
        kind="promotional-primary"
        icon={<LineInfoCircleIcon />}
        density="compact"
      >
        {message}
      </MessageBanner>
    </BannerWrap>
  )
}

export default MaldivesCharterBuyPointsBanner
